// @ts-nocheck
import { PDC_SET_FILTER } from '@/constants';

const FilterReducer = (state = [], action = {}) => {
    const filterType = action.payload?.filterType;

    switch (action.type) {
        case PDC_SET_FILTER:
            return state
                .filter(entry => entry.filterType !== filterType)
                .concat(action.payload.items.map(entry => ({ filterType, item: entry })));
        default:
            return state;
    }
};

export default FilterReducer;
